import { render, staticRenderFns } from "./PainelPdtic2017.vue?vue&type=template&id=f24ea010"
import script from "./PainelPdtic2017.vue?vue&type=script&lang=js"
export * from "./PainelPdtic2017.vue?vue&type=script&lang=js"
import style0 from "./PainelPdtic2017.vue?vue&type=style&index=0&id=f24ea010&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports